/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TreatmentTypeEnum = {
    Hp: 'HP',
    Consultation: 'CONSULTATION',
    Kev: 'KEV',
    KevEbm: 'KEV_EBM',
    KevGop: 'KEV_GOP',
    Treatment140A: 'TREATMENT_140A',
    InvirtoPb: 'INVIRTO_PB',
    Study: 'STUDY',
    BeavivoPb: 'BEAVIVO_PB',
    SzGop: 'SZ_GOP',
    PkvGop: 'PKV_GOP'
} as const;
export type TreatmentTypeEnum = typeof TreatmentTypeEnum[keyof typeof TreatmentTypeEnum];

